var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p-0"},[_c('button',{staticClass:"btn btn-sm btn-danger w-100 rounded",on:{"click":_vm.showSupport}},[_vm._v("Precisa de Ajuda?")]),(_vm.showing)?_c('form-support',{on:{"success":_vm.showSupport}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }